<mat-card class="card">
  <div class="table-container">
    <table
      class="container"
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="sortChanged($event)"
    >
      <ng-container
        *ngFor="let column of columns"
        matColumnDef="{{ column.field }}"
      >
        <th
          disabled="{{ !column.sortable }}"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by {{ column.field }}"
          class="header-cell"
        >
          <div class="d-flex flex-column column-header">
            <span>
              {{ column.label | translate }}
            </span>
          </div>
        </th>
        <ng-container [ngSwitch]="column.field">
          <ng-container *ngSwitchCase="'availabilityStatus'">
            <td mat-cell *matCellDef="let row">
              <select
                *ngIf="row.availabilityStatus !== 'NOT_ASSIGNABLE'"
                [ngModel]="row.availabilityStatus"
                class="select"
                (ngModelChange)="selectionChanged(row.merchantSiteId, $event)"
              >
                <option
                  *ngFor="
                    let status of availableStatuses.get(row.availabilityStatus)
                  "
                  [value]="status"
                >
                  {{ "PRODUCTS.STATE." + status | translate }}
                </option>
              </select>
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'pricedCustomerSegments'">
            <td mat-cell *matCellDef="let row" class="segment">
              <span
                *ngFor="
                  let segment of row.pricedCustomerSegments;
                  let last = last
                "
              >
                {{
                  "MODULES.BIG_TITLE.PRICING_SEGMENTS." + segment | translate
                }}
                {{ !last ? "," : "" }}
              </span>
            </td>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <td mat-cell *matCellDef="let row">
              <span>
                {{ customCellValue(row, column.field) }}
              </span>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <div *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</mat-card>
